module.exports = __webpack_public_path__ + "media/img/pages/companies/csl-new-09d341213b40529000ad0819b122503a.png";